import { defineStore } from "pinia";
import { ref } from "vue";

import type { GetTasksQuery } from "@/sdk";

export const useOrderStore = defineStore("orderStore", () => {
	const incompleteTasks = ref<GetTasksQuery["task"]>([]);
	const upcomingTasks = ref<GetTasksQuery["task"]>([]);

	const setIncompleteTasks = (orders: GetTasksQuery["task"]) => {
		incompleteTasks.value = orders;
	};
	const setUpcomingTasks = (orders: GetTasksQuery["task"]) => {
		upcomingTasks.value = orders;
	};

	return {
		incompleteTasks,
		setIncompleteTasks,

		upcomingTasks,
		setUpcomingTasks,
	};
});
